import { Project } from '@constants/router.const';
import { Ng2StateDeclaration } from '@uirouter/angular';

export const AUDITING_MODULE_STATE: Ng2StateDeclaration = {
  name: `dice.${Project.AUDITING}.**`,
  url: '/auditing',
  loadChildren: () => import('@auditing/app/auditing.module').then((m) => m.AuditingModule),
};
export const APP_STATES = [AUDITING_MODULE_STATE];
